import React, { createContext, useContext, useState, useCallback } from "react";
import { apiFetch } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("pz_token"));
  const [usuario, setUsuario] = useState(() => {
    const raw = localStorage.getItem("pz_usuario");
    return raw ? JSON.parse(raw) : null;
  });

  const login = useCallback(async (email, senha) => {
    const data = await apiFetch("POST", "/api/auth/login", { email, senha });
    // 2FA ativo: senha certa, mas ainda não é login de verdade — Login.js
    // trata isso pedindo o código e chamando confirmar2fa.
    if (data.precisa_2fa) return data;
    localStorage.setItem("pz_token", data.token);
    localStorage.setItem("pz_usuario", JSON.stringify(data.usuario));
    setToken(data.token);
    setUsuario(data.usuario);
    return data;
  }, []);

  const confirmar2fa = useCallback(async (tokenTemporario, codigo) => {
    const data = await apiFetch("POST", "/api/auth/login/2fa", { token_temporario: tokenTemporario, codigo });
    localStorage.setItem("pz_token", data.token);
    localStorage.setItem("pz_usuario", JSON.stringify(data.usuario));
    setToken(data.token);
    setUsuario(data.usuario);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("pz_token");
    localStorage.removeItem("pz_usuario");
    setToken(null);
    setUsuario(null);
  }, []);

  // Troca entre o perfil normal (gestor/funcionário) e o modo Admin da
  // Empresa sem deslogar — emite um token novo, sem pedir senha de novo.
  const trocarModo = useCallback(async (modo) => {
    const data = await apiFetch("POST", "/api/auth/trocar-modo", { modo }, token);
    localStorage.setItem("pz_token", data.token);
    localStorage.setItem("pz_usuario", JSON.stringify(data.usuario));
    setToken(data.token);
    setUsuario(data.usuario);
    return data;
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, usuario, login, confirmar2fa, logout, trocarModo }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
